(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.MSProjectPlannerAccessCode = api;
})(globalThis, function () {
  'use strict';
  // Shared by customer entry and the credential authority. 32 symbols, 40 bits
  // across eight uniformly generated characters; the hyphen adds no entropy.
  const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const LENGTH = 8;
  const allowed = new RegExp(`^[${ALPHABET}]{${LENGTH}}$`);
  const unsupported = new RegExp(`[^${ALPHABET}]`, 'g');
  const display = characters => characters.length > 4 ? characters.slice(0, 4) + '-' + characters.slice(4) : characters;
  function characters(value) {
    // Fold ASCII only: Unicode lookalikes must not turn into credential symbols.
    return String(value).replace(/[a-z]/g, c => c.toUpperCase()).replace(/[\s-]/g, '');
  }
  function normalize(value) {
    if (typeof value !== 'string') return null;
    const code = characters(value);
    return allowed.test(code) ? display(code) : null;
  }
  function format(value) {
    return display(characters(value).replace(unsupported, '').slice(0, LENGTH));
  }
  return Object.freeze({ALPHABET, LENGTH, normalize, format});
});
